// extracted by mini-css-extract-plugin
export default {"footer":"Configure_footer__h+8jw","head_content":"Configure_head_content__HLAEJ","tips_line":"Configure_tips_line__k-B5T"};